/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {writeOffDisputedAmount} from '../api'

export const useMutationWriteOffDisputedAmount = createReactQueryMutationHook('writeOffDisputedAmount', writeOffDisputedAmount)
